import React from 'react';
const MessageSeparateur = ({ date }) => {
    return (React.createElement("div", { className: 'messageSeparateur' },
        React.createElement("span", null),
        React.createElement("p", null, date),
        React.createElement("span", null)));
};
export default MessageSeparateur;
